import axios from "axios";
import { getAuthServiceUrl } from "../utils/urlConfig";

/**
 * Authenticates a user by sending their username and password to the login endpoint.
 */
export const login = async (username, password) => {
  const payload = {
    username: username,
    password: password,
  };

  const headers = {
    "Content-Type": "application/json",
  };

  try {
    const apiUrl = getAuthServiceUrl();
    const response = await axios.post(`${apiUrl}/login`, payload, {
      headers: headers,
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Login failed");
  }
};

/**
 * Retrieves the authentication token from local storage.
 */
export const getAuthToken = () => {
  const userStr = localStorage.getItem('user');
  if (!userStr) return null;
  try {
    const user = JSON.parse(userStr);
    return user.auth_token || user.token || user.jwt || user.jwtToken || user.accessToken;
  } catch (error) {
    console.error("Error parsing user from local storage", error);
    return null;
  }
};
